import type { GameDescriptor } from '@everyturn/engine/runtime';

export const bridgeDescriptor = {
  gameId: 'bridge',
  displayName: 'Contract Bridge',
  seats: ['north', 'east', 'south', 'west'],
  seatTeams: { north: 'North / South', south: 'North / South', east: 'East / West', west: 'East / West' },
  minPlayers: 4,
  maxPlayers: 4,
  defaultSeat: 'south',
  layoutId: 'prime-bridge',
  discovery: {
    summary:
      'Bid to discover your partnership\u2019s best trump or Notrump contract, then play both your hand and the open dummy.',
    family: 'Partnership Auction',
    playerLabel: '4 Players (2v2)',
    formatLabel: 'Chicago (4 Deals)',
  },
} as const satisfies GameDescriptor;
